import { useState, useEffect } from "react";

export default function Preloader({ onComplete }: { onComplete: () => void }) {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setVisible(false);
            setTimeout(onComplete, 500);
          }, 400);
          return 100;
        }
        return prev + Math.floor(Math.random() * 8) + 2;
      });
    }, 120);

    return () => clearInterval(interval);
  }, [onComplete]);

  if (!visible) {
    return (
      <div
        className="fixed inset-0 z-[100] flex items-center justify-center bg-background-50 transition-opacity duration-500"
        style={{ opacity: 0, pointerEvents: "none" }}
      />
    );
  }

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background-50 transition-opacity duration-500">
      <div className="flex flex-col items-center gap-8">
        {/* Spinning Key Icon */}
        <div className="relative w-20 h-20 md:w-24 md:h-24 flex items-center justify-center">
          <svg
            className="preloader-key w-16 h-16 md:w-20 md:h-20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 17C15.866 17 19 13.866 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 13.866 8.13401 17 12 17Z"
              stroke="oklch(var(--primary-500))"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 17V21"
              stroke="oklch(var(--primary-500))"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 21H15"
              stroke="oklch(var(--primary-500))"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
              stroke="oklch(var(--primary-500))"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Brand Name */}
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 tracking-wide">
          Have Received
        </h2>

        {/* Progress Bar */}
        <div className="w-56 md:w-72 h-1 bg-background-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-primary-500 rounded-full transition-all duration-150 ease-out"
            style={{ width: `${Math.min(progress, 100)}%` }}
          />
        </div>

        {/* Percentage */}
        <span className="font-label text-sm md:text-base text-foreground-600 tracking-widest tabular-nums">
          {Math.min(progress, 100)}%
        </span>
      </div>
    </div>
  );
}